interface PlansIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const PlansIcon = (props: PlansIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <g>
        <path
          style={{ fill: fillColor }}
          d="M29,30.2H9.1c-0.2,0-0.3-0.1-0.3-0.3V15.5c0-0.2,0.1-0.3,0.3-0.3h7.4v-5c0-0.2,0.1-0.3,0.3-0.3h12.2
            c0.2,0,0.3,0.1,0.3,0.3v19.6C29.3,30,29.2,30.2,29,30.2z M9.4,29.5h19.2v-19H17.2v5c0,0.2-0.1,0.3-0.3,0.3H9.4V29.5z"
        />
      </g>
      <g>
        <path d="M17.5,30.2c-0.2,0-0.3-0.1-0.3-0.3v-6.7c0-0.2,0.1-0.3,0.3-0.3l6.9-0.1c0.2,0,0.3,0.1,0.3,0.3
            c0,0.2-0.1,0.3-0.3,0.3l-6.5,0.1v6.3C17.9,30,17.7,30.2,17.5,30.2z"
        />
      </g>
      <g>
        <path d="M24.8,16C24.7,16,24.7,16,24.8,16c-0.1,0-5.4-0.6-5.4-5.8c0-0.2,0.1-0.3,0.3-0.3s0.3,0.1,0.3,0.3
            c0,3.9,3.3,4.9,4.4,5.1v-5.1c0-0.2,0.1-0.3,0.3-0.3s0.3,0.1,0.3,0.3v5.4c0,0.1-0.1,0.2-0.1,0.3C24.9,15.9,24.9,16,24.8,16z"
        />
      </g>
      <g>
        <path d="M30.9,16.2h-3.2c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h3.2c0.2,0,0.3,0.1,0.3,0.3
            C31.2,16,31,16.2,30.9,16.2z"
        />
      </g>
      <g>
        <path d="M30.9,20.5h-3.2c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h3.2c0.2,0,0.3,0.1,0.3,0.3
            C31.2,20.3,31,20.5,30.9,20.5z"
        />
      </g>
    </svg>
  )
}

export default PlansIcon
